import { SubtractSquareIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Merge = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <SubtractSquareIcon {...rest} size={Sizes[size]} color={fill} />;
};

Merge.displayName = 'Merge';
